import React from 'react';
import { Box, Typography } from '@material-ui/core';
import type { ReactNode } from 'react';

type CustomCaptionProps = {
  caption?: string;
  icon?: ReactNode;
};

const CustomCaption = ({ caption, icon }: CustomCaptionProps) => {
  return (
    <Box style={{ display: 'inline-flex', alignItems: 'center' }}>
      {icon ? (
        <span style={{ display: 'inline-flex', alignItems: 'center', marginRight: 8 }}>
          {icon}
        </span>
      ) : null}
      <Typography
        variant="caption"
        color="textSecondary"
        style={{
          fontWeight: 700,
          letterSpacing: '0.4px',
          fontSize: '0.8rem',
          lineHeight: 1.2,
        }}
      >
        {caption}
      </Typography>
    </Box>
  );
};

export default CustomCaption;
